import React from 'react';
import '../Styles/footer.css';
import logo from '../Icons/elrancho_logo2.png'

const Footer = () => {
    return(
        <footer>
            <div className="footer-container">
                <p className="title-know-us">
                    Ven a conocernos
                </p>
                <div className="address-container">
                    <a className="Location-logo-container">
                        <img src="Img/ubicacion.png"></img>
                    </a>
                    <p className="st-address">Carrer del metge mir, 23</p>
                </div>
                <div className="Logo-container-footer">
                    <img src={logo}></img>
                </div>
                <p className="title-contact">
                    Contacto
                </p>
                <div className="Contact-container">
                    <a className="Phone-logo-container">
                        <img src="Img/telefono.png"></img>
                    </a>
                    <a className="Phone-number">931704977</a>
                </div>
                <p className="title-follow-us">
                    Síguenos!
                </p>
                <div className="SocialNetworks-container">
                    <a className="Link-social">
                        <img src="Img/twitter.png"></img>
                    </a>
                    <a className="Link-social" href="https://www.instagram.com/elranchobarmexicano/">
                        <img className="ig" src="Img/instagram.png"></img>
                    </a>
                    <a className="Link-social" href="https://www.facebook.com/comidabarelrancho">
                        <img className="fb" src="Img/facebook.png"></img>
                    </a>

                </div>

            </div>
        </footer>
    )
}
export default Footer;